import { makeStyles } from '@material-ui/core';

export const historicoStyles = makeStyles({
  historicoDataHora: {
    width: '100%',
    fontWeight: 'bold',
  },
  timelineItem: {
    marginLeft: '-95%',
  },
  timelineDot: {
    backgroundColor: '#fff',
  },
});
